import { useEffect, useState } from 'react'
import { useAdminApi } from '../api'
import { t } from '../i18n'
import { useLang } from '../LangContext'

interface Usuario {
  id: string
  nombre_visible: string
  email: string
  roles: string[]
  equipo_ids: string[]
}

// Issue #27/#36: un entrenador no veía un equipo nuevo porque asignarle equipos solo era posible
// desde la pantalla de Usuarios (un paso fácil de olvidar al crear un equipo). Este panel permite
// gestionar qué entrenadores tienen este equipo asignado directamente desde Equipos, sin tener que
// ir a editar cada usuario por separado.
export function EntrenadoresAsignadosEquipo({ equipoId }: { equipoId: string }) {
  const api = useAdminApi()
  const lang = useLang()
  const [entrenadores, setEntrenadores] = useState<Usuario[]>([])
  const [loading, setLoading] = useState(true)

  async function refresh() {
    const usuarios: Usuario[] = await api.get('/admin/users')
    setEntrenadores(usuarios.filter((u) => u.roles.includes('entrenador')))
    setLoading(false)
  }

  useEffect(() => {
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipoId])

  async function handleToggle(usuario: Usuario, checked: boolean) {
    const equipoIds = checked
      ? [...usuario.equipo_ids, equipoId]
      : usuario.equipo_ids.filter((id) => id !== equipoId)
    await api.patch(`/admin/users/${usuario.id}`, { equipo_ids: equipoIds })
    await refresh()
  }

  if (loading) return null

  return (
    <div>
      <h4>{t('entrenadoresAsignados', lang)}</h4>
      {entrenadores.length === 0 && <p>{t('sinEntrenadores', lang)}</p>}
      <ul>
        {entrenadores.map((usuario) => (
          <li key={usuario.id}>
            <label>
              <input
                type="checkbox"
                checked={usuario.equipo_ids.includes(equipoId)}
                onChange={(e) => handleToggle(usuario, e.target.checked)}
              />
              {usuario.nombre_visible || usuario.email}
            </label>
          </li>
        ))}
      </ul>
    </div>
  )
}
